import { Roles } from 'enums/roles'

export const listaSelettori = [
  {
    descrizione: 'Richieste in attesa',
    codiceSelettore: 'ATTESA_SUPPORTO',
    ruoli: [Roles.SUPPORTO_FUNZIONE_AML.role, Roles.SUPPORTO_AML_DESK.role],
  },
  {
    descrizione: 'Richiesta Supporto',
    codiceSelettore: 'RICHIESTA_SUPPORTO',
    ruoli: [Roles.AML_DESK.role, Roles.SUPPORTO_FUNZIONE_AML.role],
  },
  {
    descrizione: 'Le mie Pratiche',
    codiceSelettore: 'PERSONALI',
    ruoli: [
      Roles.APPROVA_PRATICA_FIELD_ANALYST.role,
      Roles.APPROVA_PRATICA_UTENTE_BASE.role,
    ],
  },
  {
    descrizione: 'Tutte le pratiche',
    codiceSelettore: 'TUTTE',
    ruoli: [
      Roles.APPROVA_PRATICA_FIELD_ANALYST.role,
      Roles.APPROVA_PRATICA_UTENTE_BASE.role,
    ],
  },
  {
    descrizione: 'Richieste Chiuse',
    codiceSelettore: 'CHIUSE',
    ruoli: [Roles.TUTTI.role],
  },
  {
    descrizione: 'Pratiche Annullate',
    codiceSelettore: 'ANNULLATE',
    ruoli: [Roles.SUPPORTO_FUNZIONE_AML.role, Roles.UTENTE_INTERNO.role],
  },
]
